var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z",
    fill: "#DCF537"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5795 15.58C10.3795 15.58 10.1895 15.5 10.0495 15.36L7.21945 12.53C6.92945 12.24 6.92945 11.76 7.21945 11.47C7.50945 11.18 7.98945 11.18 8.27945 11.47L10.5795 13.77L15.7195 8.62998C16.0095 8.33998 16.4895 8.33998 16.7795 8.62998C17.0695 8.91998 17.0695 9.39998 16.7795 9.68998L11.1095 15.36C10.9695 15.5 10.7795 15.58 10.5795 15.58Z",
    fill: "#DCF537"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.45fbcbb8195da4239eb051dcac9b5e03.svg";
export { ForwardRef as ReactComponent };